import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { store } from './store';
import Header from './components/Layout/Header';
import Login from './components/Auth/Login';
import ImpersonatePage from './components/Auth/ImpersonatePage';
import PrivateRoute from './components/Auth/PrivateRoute';
import Products from './pages/Products';
import NewProducts from './pages/NewProducts';
import TechnicalSpecs from './pages/TechnicalSpecs';
import NewWave from './pages/NewWave';
import ManualProduct from './pages/ManualProduct';
import DataSources from './pages/DataSources';
import Statistics from './pages/Statistics';
import CheckerPage from './pages/CheckerPage';
import ChatPage from './pages/ChatPage';
import ChatModal from './components/Chat/ChatModal';
import { ChatUiProvider } from './context/ChatUiContext';
import HalloweenOverlay from './components/seasonal/HalloweenOverlay';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <Router>
        <ChatUiProvider>
          <div className="App">
            <HalloweenOverlay />
            <div
              id="chat-modal-root"
              style={{
                position: 'fixed',
                inset: 0,
                zIndex: 1100,
                pointerEvents: 'none',
              }}
            />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/impersonate" element={<ImpersonatePage />} />
              
              <Route path="/" element={<PrivateRoute />}>
                <Route index element={<Navigate to="/products" replace />} />
                <Route path="products" element={
                  <>
                    <Header />
                    <Products />
                  </>
                } />
                <Route path="new-products" element={
                  <>
                    <Header />
                    <NewProducts />
                  </>
                } />
                <Route path="technical-specs" element={
                  <>
                    <Header />
                    <TechnicalSpecs />
                  </>
                } />
                <Route path="new-wave" element={
                  <>
                    <Header />
                    <NewWave />
                  </>
                } />
                <Route path="manual-product" element={
                  <>
                    <Header />
                    <ManualProduct />
                  </>
                } />
                <Route path="data-sources" element={
                  <>
                    <Header />
                    <DataSources />
                  </>
                } />
                <Route path="statistics" element={
                  <>
                    <Header />
                    <Statistics />
                  </>
                } />
                <Route path="chat" element={
                  <>
                    <Header />
                    <ChatPage />
                  </>
                } />
                <Route path="products/checker" element={
                  <>
                    <Header />
                    <CheckerPage />
                  </>
                } />
                <Route path="products/:id" element={
                  <>
                    <Header />
                    <div className="container py-4">
                      <h2>Детали товара</h2>
                      <p>Страница деталей товара будет реализована позже</p>
                    </div>
                  </>
                } />
                <Route path="*" element={<Navigate to="/products" replace />} />
              </Route>

              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            
            <ChatModal />
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </ChatUiProvider>
      </Router>
    </Provider>
  );
}

export default App;
